import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Clock, LogOut, PackageOpen, Ban } from "lucide-react";
import { Button } from "@/components/ui/button";

const COPY = {
  pending: {
    icon: Clock, tone: "#F59E0B",
    title: "Your account is awaiting approval",
    body: "Thanks for signing up! An administrator needs to approve your account before you can start your trial. You'll get access as soon as it's approved.",
  },
  suspended: {
    icon: Ban, tone: "#EF4444",
    title: "Your account is suspended",
    body: "Access to your account has been paused. Please contact support if you think this is a mistake.",
  },
};

export default function PendingApproval({ variant = "pending" }) {
  const { user, logout } = useAuth();
  const c = COPY[variant] || COPY.pending;
  const Icon = c.icon;
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white px-6" data-testid={`account-gate-${variant}`}>
      <div className="max-w-md text-center">
        <div className="flex items-center justify-center gap-2 mb-8">
          <PackageOpen className="h-6 w-6 text-[#007AFF]" />
          <span className="font-head font-extrabold text-lg text-white">FBAStar</span>
        </div>
        <div className="h-16 w-16 rounded-full flex items-center justify-center mx-auto" style={{ background: `${c.tone}26` }}>
          <Icon className="h-8 w-8" style={{ color: c.tone }} />
        </div>
        <h1 className="font-head font-extrabold text-2xl mt-6">{c.title}</h1>
        <p className="text-sm text-[#A3A3A3] mt-3">{c.body}</p>
        <Button onClick={logout} variant="outline" data-testid="pending-logout"
          className="mt-8 bg-[#111] border-[#262626] text-white hover:bg-[#1a1a1a] hover:text-white rounded-full">
          <LogOut className="h-4 w-4 mr-2" /> Sign out
        </Button>
      </div>
    </div>
  );
}
